import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IDocumentSearchResultItem } from '../shared/models/document-search-result-item';
import { Subscription } from 'rxjs';
import { IUser } from '../../../shared/models/user';
import { SearchResultLayout } from '../shared/constants/search-results-layout';
import { DocumentService } from '../shared/services/document.service';

@Component({
    selector: 'app-document-search-result-card',
    templateUrl: './document-search-result-card.component.html',
    styleUrl: './document-search-result-card.component.scss',
    standalone: false
})
export class DocumentSearchResultCardComponent implements OnChanges {
  @Input() searchResultItem: IDocumentSearchResultItem | null = null;
  @Input() index: number | null = null;
  @Input() layout: SearchResultLayout = SearchResultLayout.Grid;

  readonly searchResultLayoutEnum = SearchResultLayout;
  documentType: string = '';
  documentStatus: string = '';
  subscriptions: Subscription = new Subscription();
  currentUser: IUser | null = null;
  uri: string = '';
  
  constructor(
    private _documentService: DocumentService,
  ) {}

  ngOnChanges(changes : SimpleChanges): void {
    if (changes['searchResultItem']) {
      const newItem = changes['searchResultItem'].currentValue;
      this.searchResultItem = newItem;
      this.setValues();
    }
  }

  setValues() {
    this.documentType = this.searchResultItem?.docType ? this.searchResultItem.docType : '';
    this.documentStatus = this.searchResultItem?.status ? this.searchResultItem.status : '';
    this.uri = this.getDocumentUri();
  }

  getDocumentUri() : string {
    return this._documentService.extractUriFromSearchableUri(this.searchResultItem?.uri);
  }

}
